import { IPageTeaser } from 'src/models/page-teaser.model';
import { EntityActions } from '../entity.actions';

export const fromPageTeaserActions = EntityActions.create<IPageTeaser>('[Page Teaser]');
